import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_DOMAIN;

export const authAxios = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

authAxios.interceptors.response.use(
  (response) => {
    if (response.status === 200) return response.data;
    return Promise.reject(response.data);
  },
  (error) => {
    const { response } = error;

    const message = response?.data || "Something Went Wrong";
    return Promise.reject(message);
  }
);
